import urljoin from 'urljoin'
import { urlList } from '@/xhr'
import { getUid, getUserPhone, getUsername } from './role'
import moment from 'moment'
// 相册部分
import './viewer-customer.scss'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'
import accountXHR from '@/xhr/services/account'
export default {
  created() {},
  components: {
    Viewer,
  },
  data() {
    return {
      urlList,
      ONE_DAY: 24 * 3600 * 1000,
      MONEY_SIZE: 1000,
      viewerOptions: {
        title: true,
        navbar: false,
        className: 'viewer-customer',
        $viewer: {},
        toolbar: {
          oneToOne: { show: false },
          zoomIn: { show: true, size: 'large' },
          zoomOut: { show: true, size: 'large' },
          reset: { show: false },
          prev: { show: true, size: 'large' },
          play: { show: false },
          next: { show: true, size: 'large' },
          rotateLeft: { show: true, size: 'large' },
          rotateRight: { show: true, size: 'large' },
          flipHorizontal: { show: false },
          flipVertical: { show: false },
        },
      },
    }
  },

  filters: {
    tryParseJsonString(jsonStr, defaultValue) {
      let ret = defaultValue
      if (jsonStr) {
        try {
          ret = JSON.parse(jsonStr) || defaultValue
        } catch (e) {
          console.warn('JSON格式不正确，解析失败', e.message)
        }
      }

      return ret
    },
  },

  methods: {
    noop() {},

    // 展示图片 为了支持多个相册的功能
    showImg(viewerIndex, index) {
      let viewer = this.$refs[`viewer${viewerIndex}`]
      viewer = Array.isArray(viewer) ? viewer[0] : viewer
      viewer.$viewer.view(index)
    },
    setUnitIds() {
      if (this.getUid()) {
        accountXHR.getUserInfoOfZone(this.getUserPhone()).then(res => {
          if (
            res.data.data &&
            res.data.data.unitBeans &&
            Array.isArray(res.data.data.unitBeans)
          ) {

            const unitBeans = res.data.data.unitBeans
            this.$store.commit('SET_CURRENT_UNIT_IDS', unitBeans.map(o => o.id))
          }
        })
      }
    },

    /**
     *
     * @param {*} value  根据值
     * @param {*} obj 对象值
     */
    getKeyByValue(value, obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (obj[prop] === value) {
            return prop
          }
        }
      }
      return null
    },
    /**
     * @author zhangbing
     * @param [] arr 需要重置的数组变量
     * @param {*} options 配置对象 对于这里的重置规则如果不符合需求的可以自定义option字典,然后用instanceof 判断类型（todo）
     */
    resetVars(arr, options) {
      if (!arr || arr.length === 0) return
      let _options = {
        object: {},
        string: '',
        number: 0,
        boolean: true,
        null: null,
        undefined: undefined,
      }
      _options = options ? Object.assign({}, _options, options) : _options
      return arr.map(item => {
        if (_options.includes(typeof item)) {
          item = _options[typeof item]
        } else {
          // 不存在重置类型的 重置为字符串
          item = ''
        }
        return item
      })
    },

    /**
     * @author zhangbing
     * @param [] arr 支持传入数组[source:sourceObj,propArr:[]],分贝为源对象 拷贝属性数组
     */

    setProps(arr) {
      if (arr.length <= 0) return {}
      return arr.reduce((acc, item) => {
        item.propArr.reduce((acc, prop) => {
          if (typeof item.source[prop] === 'object') {
            acc[prop] = JSON.parse(JSON.stringify(item.source[prop]))
          } else {
            acc[prop] = item.source[prop]
          }
          return acc
        }, acc)
        return acc
      }, {})
    },
    urljoin,
    getUid,
    getUserPhone,
    getUsername,
    moment,
  },
}



// WEBPACK FOOTER //
// ./src/mixins/index.js